<template>
  <v-card class="ma-0" width="100%" style="height: calc(100vh - 100px)" elevation="2">
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{ $t("businessList") }}</v-toolbar-title>
      <div v-if="!isMobile && !mobileShow" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <!-- ADD FILTER -->
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="filter = true"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <!-- ADD FILTER -->
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2 pa-0">
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.row="{ item, index }">
          <v-card-text class="pa-0 text-caption text-disable">
            {{ index + 1 }}
          </v-card-text>
        </template>
        <template v-slot:item.business="{ item }">
          <v-container
            @click="visitPlanEditor(item)"
            style="cursor: pointer; color: #0066ff"
            class="pa-0 d-flex gap-2"
          >
            <span style="color: rgb(98 98 98 / 87%)">#{{ item.customer.id }}</span>
            <span class="text-body-2">{{
              item.business_name ? item.business_name : $t("haveNot")
            }}</span>
          </v-container>
          <span style="color: rgb(98 98 98 / 87%)">{{
            item.customer.app_key ? item.customer.app_key : $t("haveNot")
          }}</span>
        </template>
        <template v-slot:item.owner="{ item }">
          <v-card-text class="text-body-2 pa-0">{{
            item.full_name ? item.full_name : $t("haveNot")
          }}</v-card-text>
          <v-card-text class="text-caption pa-0" style="color: rgb(98 98 98 / 87%)">{{
            item.mobile ? item.mobile : $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.plan_name="{ item }">
          <span class="text-body-2">
            {{ item.plan && item.plan.plan ? item.plan.plan.name : $t("haveNot") }}
          </span>
        </template>
        <template v-slot:item.current_plan_expire_date="{ item }">
          <v-container class="pa-0 d-flex gap-2">
            <span class="text-body-2">{{
              item.plan ? item.plan.ends_at : $t("haveNot")
            }}</span>
          </v-container>
        </template>
        <template v-slot:item.business_create_date="{ item }">
          <span class="text-body-2">{{
            item.customer ? item.customer.created_at : $t("haveNot")
          }}</span>
        </template>
        <template v-slot:item.smsCountRemain="{ item }">
          <span class="text-body-2">{{
            item.sms_balance ? item.sms_balance : $t("haveNot")
          }}</span>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <!-- ADD FILTER -->
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromCreateDateId"
                v-model="fromCreateDate"
                :label="$t('from') + ' ' + $t('business-create-date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromCreateDate"
                element="fromCreateDateId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toCreateDateId"
                v-model="toCreateDate"
                :label="$t('until') + ' ' + $t('business-create-date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="toCreateDate"
                element="toCreateDateId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromCreateDate"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromExpireDateId"
                v-model="fromExpireDate"
                :label="$t('from') + ' ' + $t('current-plan-expire-date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromExpireDate"
                element="fromExpireDateId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toExpireDateId"
                v-model="toExpireDate"
                :label="$t('until') + ' ' + $t('current-plan-expire-date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="toExpireDate"
                element="toExpireDateId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromExpireDate"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <FlexibleAutocomplete
              v-model="selectedPlans"
              title="plan-name"
              type="plan"
              :multiple="true"
              :fetch-data="fetchPlansApi"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn class="mx-0" color="primary" @click="applyFilter">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ADD FILTER -->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <Confirm ref="confirm" />
  </v-card>
</template>

<script>
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
import FlexibleAutocomplete from "../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "businessList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../components/general/AIcomplete/index"),
    filePicker,
    FlexibleAutocomplete,
  },
  mixins: [General],
  props: ["input", "type", "refId", "mobileShow", "titleProp"],
  data: () => ({
    selected: [],
    pageCount: 1,
    page: 1,
    selectedHeaders: [],
    deletDialog: false,
    showSelect: true,
    model: null,
    from: 1,
    temp: null,
    deleteItem: null,
    items: [],
    sortBy: [],
    dialog: null,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    search: null,
    filter: false,
    fromCreateDate: null,
    toCreateDate: null,
    fromExpireDate: null,
    toExpireDate: null,
    selectedPlans: [],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isTablet() {
      const breakpointName = this.$vuetify.breakpoint.name;
      return breakpointName === "sm" || breakpointName === "md";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
      immediate: false,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  beforeMount() {
    //   if (this.$route.name === 'mainGroup') {
    //     this.typeForm = 'group'
    //   }
    this.headers = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("business"),
        sortable: false,
        value: "business",
      },
      {
        text: this.$t("owner"),
        sortable: false,
        value: "owner",
      },
      {
        text: this.$t("plan-name"),
        sortable: false,
        value: "plan_name",
      },
      {
        text: this.$t("current-plan-expire-date"),
        sortable: false,
        value: "current_plan_expire_date",
      },
      {
        text: this.$t("business-create-date"),
        sortable: false,
        value: "business_create_date",
      },
      {
        text: this.$t("smsCountRemain"),
        sortable: false,
        value: "smsCountRemain",
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
  },
  methods: {
    fetchPlansApi(payload) {
      var app = this;
      const storage = JSON.parse(localStorage.getItem("token"));
      const abr = storage?.init?.appBarsOpacity?.abr;
      const endpoint = "https://plans.abriron.com/api/";
      return app.$axios
        .get(endpoint + "plan-duration", {
          headers: {
            "X-API-KEY": "ZEBQXqT6fYykTWRh9zhqJCBTtXfM1MXTmjIcYHw",
            abr: abr,
          },
          params: {
            type: "all",
          },
        })
        .then(function (r) {
          let allPlans = r.data.flatMap((item) => item.plans);
          allPlans = [...new Map(allPlans.map((p) => [p.id, p])).values()];
          const search = (payload.search || "").trim();
          if (search) {
            allPlans = allPlans.filter((p) => p.name.includes(search));
          }
          return {
            items: allPlans,
            hasMore: false,
          };
        })
        .catch(function (err) {
          app.serverErrorHandeler(err);
          return { items: [], hasMore: false };
        });
    },
    applyFilter() {
      this.page = 1;
      this.getItems();
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      const hasFilter = !(app.search || "").trim();
      app.$axios
        .get(this.$endpoint + "customers", {
          params: {
            page: app.options.page,
            search: this.search,
            options: app.options,
            sortBy: app.sortBy,
            created_from: app.fromCreateDate || null,
            created_to: app.toCreateDate || null,
            expire_from: app.fromExpireDate || null,
            expire_to: app.toExpireDate || null,
            plan_ids: app.selectedPlans.map((p) => p.id) || [],
            filter: hasFilter ? true : undefined,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.meta.total;
          app.pageCount = res.meta.last_page;
          app.from = res.meta.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    visitPlanEditor(item) {
      this.$router.push({
        name: "planAdministration",
        params: { abr: item.customer?.id, name: item.full_name },
      });
    },
  },
};
</script>

<style scoped>
::v-deep .ma-0.mt-0.pt-0.v-card.v-card--flat.v-sheet.theme--light {
  width: auto !important;
}
::v-deep .v-avatar.rounded {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
